import React from 'react';
import styles from './Slogan.module.css';

const Slogan = () => {
  return (
    <div className={styles.slogan}>
      <h2>Connecting Ideas.</h2>
      <h2>Empowering Innovation</h2>
    </div>
  );
};

export default Slogan;